module.exports = __webpack_public_path__ + "0352581498b486ef9efba8c6bb53a9e3.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/screenprint-tshirt-white-design-resized.png
// module id = 809
// module chunks = 0